




































import Vue from 'vue';
import { State, Getter, Mutation } from 'vuex-class';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class ChartEdit extends Vue {
  @Mutation('EDIT_COMP') private EDIT_COMP: any;
  @Prop() private i!: any;
  @Prop() private index!: number;
  @Prop() private intervalTime!: any;
}
